import { Component } from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setHeaderTitle } from '../../store/layout/actionCreator'

export class HeaderTitle extends Component {
  static propTypes = {
    setHeaderTitle: func,
    title: string,
    icon: string,
    subtitle: string,
  }

  componentDidMount() {
    this.props.setHeaderTitle({
      headerTitle: this.props.title,
      headerIcon: this.props.icon,
      headerSubtitle: this.props.subtitle,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.title !== this.props.title ||
      nextProps.icon !== this.props.icon ||
      nextProps.subtitle !== this.props.subtitle
    ) {
      this.props.setHeaderTitle({
        headerTitle: nextProps.title,
        headerIcon: nextProps.icon,
        headerSubtitle: nextProps.subtitle,
      })
    }
  }

  render() {
    return null
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setHeaderTitle }, dispatch)

export default connect(null, mapDispatchToProps)(HeaderTitle)
